import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SERVICES } from "@/data/services";

const Col = ({ title, links }) => (
  <div>
    <p className="mb-5 text-xs font-semibold uppercase tracking-[0.28em] text-[#D4AF37]">{title}</p>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.to}>
          <Link to={l.to} className="text-sm text-[#CFE7E3] transition-colors duration-300 hover:text-white" data-testid={`footer-link-${l.to.replace(/\//g, "-").slice(1) || "home"}`}>
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="relative overflow-hidden bg-[#063A36] text-white grain" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-6 pt-20 lg:px-12 lg:pt-28">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo light />
          <p className="font-display mt-8 text-xl font-semibold text-white">Simplifying HR. Amplifying Business.</p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-[#CFE7E3]">One partner across People, HR & Leadership.</p>
          <div className="mt-8 space-y-2 text-sm text-[#CFE7E3]" data-testid="footer-contact">
            <a href="mailto:hr@krimzon.in" className="block font-semibold text-white transition-colors hover:text-[#D4AF37]" data-testid="footer-email">hr@krimzon.in</a>
            <p>Thane West, Mumbai, India – 400608</p>
          </div>
        </div>
        <div className="md:col-span-4">
          <Col title="Solutions" links={SERVICES.map((s) => ({ to: `/services/${s.slug}`, label: s.title }))} />
        </div>
        <div className="md:col-span-3">
          <Col title="Firm" links={[{ to: "/about", label: "About" }, { to: "/beyond", label: "Beyond" }, { to: "/services", label: "All Solutions" }, { to: "/contact", label: "Talk to Krimzon" }]} />
        </div>
      </div>
      <p className="font-display outline-text mt-20 select-none whitespace-nowrap text-[18vw] font-extrabold leading-[0.8] tracking-tight lg:text-[17vw]" aria-hidden>
        KRIMZON
      </p>
      <div className="flex flex-col justify-between gap-3 border-t border-white/10 py-8 text-xs text-[#A9CFCA] md:flex-row">
        <span data-testid="footer-legal-name">© 2026 Krimzon Workforce Solutions Private Limited. All rights reserved.</span>
        <span>Excellence · Ease · Experience</span>
      </div>
    </div>
  </footer>
);
